import React, { Component } from "react";
import { Translate } from "react-redux-i18n";
import "../../styles/components/static/NotFound.scss";
import "../../styles/components/link/InstallationSteps.scss";
import EVIO_logo from "../../styles/images/link/EVIO_logo.svg";
import google_play from "../../styles/images/link/google_play.svg";
import apple from "../../styles/images/link/apple.svg";
import Group_33199 from "../../styles/images/link/Group_33199.png";
import Group_33202 from "../../styles/images/link/Group_33202.png";

class InstallationSteps extends Component {
	constructor(props) {
		super(props);
		this.state = {};
	}

	render() {
		return (
			<div id='container-static'>
				<div id='container-moving'>
					<div id='header'>
						<img id='evio-logo' src={EVIO_logo} alt='' />
					</div>
					<div id='start-txt'>
						<Translate value='InstallationSteps_header_start1' />
						&nbsp;
						<p id='start-text-bold'>
							<Translate value='InstallationSteps_header_start2' />
						</p>
					</div>
					<div id='step1'>
						<div id='download-txt'>
							<h2 id='n1'>1</h2>
							<Translate value='InstallationSteps_step1_download' />
							<p id='install-txt'>
								<Translate value='InstallationSteps_step1_install' />
							</p>
						</div>
						<div id='stores'>
							<div id='app-store'>
								<a
									className='anchor'
									id='anchor'
									href='https://apps.apple.com/us/app/evio/id1539284689'
									target='_blank'
									rel='noreferrer'
								>
									<div className='rectangle'>
										<div className='logos'>
											<img src={apple} alt='' />
										</div>
										<div id='ios-text'>
											<Translate value='InstallationSteps_step1_appStore' />
											&nbsp;
											<p id='ios-text-bold'>
												<Translate value='InstallationSteps_footer_ios' />
											</p>
										</div>
									</div>
								</a>
							</div>
							<div id='google-store'>
								<a
									href='https://play.google.com/store/apps/details?id=com.evio.evio'
									target='_blank'
									rel='noreferrer'
								>
									<div className='rectangle'>
										<div className='logos'>
											<img src={google_play} alt='' />
										</div>
										<div id='android-text'>
											<Translate value='InstallationSteps_step1_googlePlay' />
											&nbsp;
											<p id='android-text-bold'>
												<Translate
													value='InstallationSteps_footer_android'
													id='android'
												/>
											</p>
										</div>
									</div>
								</a>
							</div>
						</div>
					</div>
					<div id='step2'>
						<div id='signup-txt'>
							<h2 id='n2'>2</h2>
							<Translate value='InstallationSteps_step2_signUp' />
						</div>
						<div id='openapp-txt'>
							<Translate value='InstallationSteps_step2_openApp' />
						</div>
					</div>
					<div id='phones'>
						<img src={Group_33199} alt='' id='3phones' />
					</div>
					<div id='step3'>
						<h2 id='n3'>3</h2>
						<div id='scan-charge-txt'>
							<Translate value='InstallationSteps_step3_scan' />
						</div>
						<div id='scan-qr-txt'>
							<Translate value='InstallationSteps_step3_scanQRcode' />
						</div>
					</div>
					<div id='phone-hand'>
						<img src={Group_33202} alt='' />
					</div>

					<div id='footer'>
						<div id='allset-txt'>
							<Translate value='InstallationSteps_footer_ready' />
						</div>
						<div id='thanks-txt'>
							<Translate value='InstallationSteps_footer_thankYou' />
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default InstallationSteps;
